var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcmnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0067 3.89998L9.04666 1.61331C8.39999 1.23998 7.59999 1.23998 6.94666 1.61331L2.99332 3.89998C2.34666 4.27331 1.94666 4.96665 1.94666 5.71998V10.28C1.94666 11.0266 2.34666 11.72 2.99332 12.1L6.95332 14.3866C7.59999 14.76 8.39999 14.76 9.05332 14.3866L13.0133 12.1C13.66 11.7266 14.06 11.0333 14.06 10.28V5.71998C14.0533 4.96665 13.6533 4.27998 13.0067 3.89998ZM7.99999 4.89331C8.85999 4.89331 9.55332 5.58665 9.55332 6.44665C9.55332 7.30665 8.85999 7.99998 7.99999 7.99998C7.13999 7.99998 6.44666 7.30665 6.44666 6.44665C6.44666 5.59331 7.13999 4.89331 7.99999 4.89331ZM9.78666 11.1066H6.21332C5.67332 11.1066 5.35999 10.5066 5.65999 10.06C6.11332 9.38665 6.99332 8.93331 7.99999 8.93331C9.00666 8.93331 9.88666 9.38665 10.34 10.06C10.64 10.5 10.32 11.1066 9.78666 11.1066Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcmnd);
export default __webpack_public_path__ + "static/media/icmnd.0d606a20dfaed8fdfe73872708e03389.svg";
export { ForwardRef as ReactComponent };